import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { KlientAlternatywny } from '../../../shared/models/klient.model';

@Component({
  selector: 'ngx-wybor-klienta',
  templateUrl: './wybor-klienta.component.html',
  styleUrls: ['./wybor-klienta.component.scss'],
})
export class WyborKlientaComponent implements OnInit, OnChanges {

  @Input()
  klienci: KlientAlternatywny[];

  wyborFirmyMenuTag = 'kontakt';

  wyborFirmyMenu = [
    {
      title: '',
      link: '',
    },
  ];

  constructor() { }

  ngOnInit() {
    this.buildMenu();
  }

  ngOnChanges() {
    this.buildMenu();
  }

  private buildMenu() {
    this.wyborFirmyMenu = [];

    if (this.klienci && this.klienci.length > 0) {
      for (const klient of this.klienci) {
        this.wyborFirmyMenu.push({ 
          title: klient.nazwa, 
          link: '/auth/relogin/' + klient.id,
        });
      }
    }
  }
}
